import { guid } from '@/mixins/guid';

const image = num => ({
  _id: guid.methods.guid(),
  src: `${process.env.S3_ASSETS_URL}mock-images/default-images/image-${num}.svg`,
  altText: false,
  subTitle: false,
});

export default function imageGallery() {
  return {
    _id: false,
    type: 'droplet.imageGallery',
    firstUpload: false,
    images: [image(1), image(2), image(3), image(4)],
    bounceDroplet: false,
    mediaQueries: [],
    pageCSS: '',
    showAll: false,
    itemLimit: 4,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/image-gallery/droplet.schema.js